import React from 'react';
import UserProfile from '../auth/UserProfile';
import './Header.css';

const Header = ({ currentSection, onSectionChange, user, onSignOut, onSignInClick }) => {
  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <h1>Dinner.Haus</h1>
        </div>
        <nav className="nav">
          <button 
            className={`nav-button ${currentSection === 'dinner' ? 'active' : ''}`}
            onClick={() => onSectionChange('dinner')}
          >
            Dinner Haus
          </button>
          <button 
            className={`nav-button ${currentSection === 'drink' ? 'active' : ''}`}
            onClick={() => onSectionChange('drink')}
          >
            Drink Haus
          </button>
          <button 
            className={`nav-button ${currentSection === 'planner' ? 'active' : ''}`}
            onClick={() => onSectionChange('planner')}
          >
            Weekly Planner
          </button>
        </nav>
        <div className="header-auth">
          {user ? (
            <UserProfile user={user} onSignOut={onSignOut} />
          ) : (
            <button className="sign-in-button" onClick={onSignInClick}>
              Sign In
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;